import React from 'react';

import CountryHeader from './CountryHeader';
import CountrySections from './CountrySections';

const CountryInfo = ({ info }) => (
    <div className="eds-g-group">
        <CountryHeader info={info} />
        <CountrySections sections={info.sections} />
    </div>
);

export default CountryInfo;
